import {dehydrate, QueryClient} from '@tanstack/react-query';
import {getDehydratedOptions} from './getDehydratedOptions';
import {IS_CLIENT_SIDE} from './shared/utils/constants';
import {DehydratedProps} from './type';

/**
 * SSR 환경에서 hydrate할 때 필요한 상태와 옵션을 dehydrate하여 리턴합니다.
 */
export function getDehydratedState(
  queryClient: QueryClient
): Omit<DehydratedProps, 'hasErrorQuery'> {
  const result = {
    dehydratedState: dehydrate(queryClient),
    dehydratedQueryOptions: getDehydratedOptions(queryClient),
  };
  !IS_CLIENT_SIDE && queryClient.clear(); // 서버사이드 메모리 누수 방지를 위해 dehydratedState 생성 후 캐시를 비웁니다. 참고 : https://tanstack.com/query/v3/docs/react/guides/ssr#high-memory-consumption-on-server
  return result;
}
